/**
 * Frame colour per parking lot, so staff and driver recognise the lot at a
 * glance instead of reading the name off a screen in the dark. Mirrors the
 * app's lib/screens/tickets/widgets/parking_field_colors.dart — keep the two
 * in sync.
 *
 * Keyed by the field's slug: the name is admin-editable (the client renames
 * lots) and the ids differ between dev and prod, while the slug is seeded by
 * migration and identical everywhere.
 *
 * BernExpo Parking is deliberately absent — it keeps its own white QR-only
 * design, and a lot without an entry here simply renders unframed.
 *
 * NPZ's blue is fixed by the client's mockup. The remaining four colours are
 * the mockup's Parkfeld B, C, D and E in order, laid onto the other lots in
 * the order the admin lists them (by name, ascending) — so the mapping has a
 * rule behind it rather than being arbitrary.
 */
const parkingFieldColors = {
  npz: '#2978D4',
  'bernexpo-deckel-a': '#EB6834',
  'bernexpo-deckel-b': '#1BAF79',
  papiermuehlestrasse: '#ECA100',
  pentagon: '#4A3AA7',
};

export default (slug) => (slug ? parkingFieldColors[slug] : undefined);
